import { createContext } from "react";
const ManageTagsContext = createContext();
export default ManageTagsContext;
